import { render, staticRenderFns } from "./ReadyToPick.vue?vue&type=template&id=4d3813b8&scoped=true"
import script from "./ReadyToPick.vue?vue&type=script&lang=js"
export * from "./ReadyToPick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3813b8",
  null
  
)

export default component.exports